export const preexistingConditions = [
  "None",
  "Diabetes",
  "Hypertension",
  "Coronary artery disease",
  "Congestive heart failure",
  "COPD",
  "Asthma",
  "Chronic kidney disease",
  "Cancer",
  "HIV/AIDS",
  "Stroke",
  "Liver disease",
  "Mental health condition",
  "Others"
];